import { styled } from "@mui/material";

export const UpdateGroupWrapper = styled("form")(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "var(--flex-gap)",
    "& fieldset": {
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      "& .group-members-stack": {
        gap: "calc(var(--flex-gap)/2)",
        padding: "calc(var(--basic-padding)) 0",
        "& .group-member-information": {
          flexGrow: 1,
          gap: "var(--flex-gap)",
          "& fieldset": {
            flex: 1,
          },
        },
      },
    },
    [theme.breakpoints.up("miniTablet")]: {
      "& fieldset": {
        "& .group-members-stack": {
          "& .group-member-information": {
            flexDirection: "row",
          },
        },
      },
    },
  };
});
